const getters = {
  userInfo: state => state.user.userInfo,
  userMoney: state => state.user.userMoney,
  userLevel: state => state.user.userLevel,
  popPicInfo: state => state.user.popPicInfo,
  userCart: state => state.user.userCart,
  noticeList: state => state.user.noticeList,
  noticeNum: state => state.user.noticeNum,
  chatUnread: state => state.user.chatUnread,
  chatGroupLastChange: state => state.user.chatGroupLastChange,
  chatGroupRecord: state => state.user.chatGroupRecord,
  userCartItems: state =>
    state.user.userCart.reduce((items, shop) => items.concat(shop.carts), []),
  userCartItemCount: state =>
    state.user.userCart.reduce((sum, shop) => sum + shop.carts.length, 0),
  userCartTotalPrice: state =>
    state.user.userCart.reduce(
      (sum, shop) =>
        sum +
        shop.carts.reduce((sum, cart) => sum + cart.number * priceDiscount(shop, cart), 0),
      0
    ),

  dictEnumMapAll: state => state.common.dictEnumMapAll,
  paramMapAll: state => state.common.paramMapAll,
  countryList: state => state.common.countryList,
  country: state => state.common.country,
  systemVersion: state => state.common.systemVersion,
  siteTitle: state => state.common.siteTitle,
  language: state => state.common.language,
  langCode: state => state.common.langCode,
  noticeRead: state => state.common.noticeRead,
  currency: state => state.common.currency,
  forceLoginOpen: state => state.common.forceLoginOpen,

  selectedGameTypeCode: state => state.bet.selectedGameTypeCode
};

export default getters;
function priceDiscount(shop, goods) {
  if (!shop.isSeckillShop) return goods.price
  let buyDiscount = goods.buyDiscount || 100;
  return goods.price * buyDiscount / 100
}
